import { SessionStorageKeys } from "@/enums";

export default () => {
  sessionStorage.setItem(
    SessionStorageKeys.PostLoginURL,
    window.location.pathname,
  );
};
